import { apiClient } from '@/lib/api/client'

export interface ChartData {
  labels: string[]
  data: number[]
}

export interface UserRegistrationReport {
  trend: ChartData
  by_role: ChartData
  by_status: ChartData
  summary: {
    total: number
    active: number
    inactive: number
  }
}

export interface UserEngagementReport {
  active_users: Array<{
    user_id: number
    user_name: string
    activity_count: number
  }>
  activity_timeline: ChartData
  summary: {
    active_7d: number
    active_30d: number
    active_90d: number
  }
}

export interface UserDemographicsReport {
  by_role: ChartData
  by_status: ChartData
}

export const userReportsService = {
  async getRegistrationReport(filters?: {
    start_date?: string
    end_date?: string
    period?: 'daily' | 'weekly' | 'monthly'
  }): Promise<UserRegistrationReport> {
    const params = new URLSearchParams()
    if (filters?.start_date) params.append('start_date', filters.start_date)
    if (filters?.end_date) params.append('end_date', filters.end_date)
    if (filters?.period) params.append('period', filters.period)

    const response = await apiClient.get(`/analytics/user-reports/registration?${params.toString()}`)
    return response.data.data
  },

  async getEngagementReport(filters?: { start_date?: string; end_date?: string }): Promise<UserEngagementReport> {
    const params = new URLSearchParams()
    if (filters?.start_date) params.append('start_date', filters.start_date)
    if (filters?.end_date) params.append('end_date', filters.end_date)

    const response = await apiClient.get(`/analytics/user-reports/engagement?${params.toString()}`)
    return response.data.data
  },

  async getDemographicsReport(): Promise<UserDemographicsReport> {
    const response = await apiClient.get('/analytics/user-reports/demographics')
    return response.data.data
  },
}

